import type { DevAgentChatSessionRow } from "./types";

/** Persist last-open dev-agent chat so a full page reload re-selects the same session. */
export function devAgentLastSessionStorageKey(userId: string, orgId: string | undefined) {
  return `dev-agent:last-session:${userId}:${orgId ?? ""}`;
}

export function persistLastDevAgentSession(
  userId: string | undefined,
  orgId: string | undefined,
  sessionUuid: string | null,
) {
  if (!userId || !sessionUuid) return;
  try {
    sessionStorage.setItem(devAgentLastSessionStorageKey(userId, orgId), sessionUuid);
  } catch {
    /* private mode / quota */
  }
}

export function pickPreferredDevAgentSession(
  sessions: DevAgentChatSessionRow[],
  userId: string,
  orgId: string | undefined,
) {
  if (sessions.length === 0) return null;
  let preferredUuid = sessions[0].uuid;
  try {
    const stored = sessionStorage.getItem(devAgentLastSessionStorageKey(userId, orgId));
    if (stored && sessions.some((session) => session.uuid === stored)) {
      preferredUuid = stored;
    }
  } catch {
    /* ignore */
  }
  return sessions.find((session) => session.uuid === preferredUuid) || sessions[0];
}
